import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import ArrowDown from 'apollo-react-icons/ArrowDown';
import ArrowUp from 'apollo-react-icons/ArrowUp';
import DeleteIcon from 'apollo-react-icons/Trash';
import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { validateSavedSearch } from '../../actions/editor.actions';
import { MOVE_TABLE_ROW_DOWN, MOVE_TABLE_ROW_UP } from '../../constants/editor.constants';
import { getValidationErrors } from '../../selectors/editor.selectors';

const useStyles = makeStyles({
  actions: {
    display: 'flex',
    textAlign: 'center',
  },
  selected: {
    '& svg': {
      fill: 'white',
    },
  },
});

const ActionCell = ({ row }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const validationErrors = useSelector(getValidationErrors);

  const handleSelectRow = () => {
    row.handleSelectRow && row.handleSelectRow({ rowId: row.rowId });
  };

  const handleDeleteButtonClick = () => {
    row.deleteRow({ rowId: row.rowId });
    validationErrors.length && dispatch(validateSavedSearch());
  };

  const handleArrowUp = (row) => {
    handleSelectRow();
    row.moveRow({ rowId: row.rowId, currentIndex: row.index, moveAction: MOVE_TABLE_ROW_UP });
  };

  const handleArrowDown = (row) => {
    handleSelectRow();
    row.moveRow({ rowId: row.rowId, currentIndex: row.index, moveAction: MOVE_TABLE_ROW_DOWN });
  };

  const isFirstRow = row.index === 0;
  const isLastRow = row.index === row.rowsLength - 1;

  return (
    <div className={classNames(classes.actions, row.isSelected && classes.selected)}>
      {row.enableRowMovement && (
        <>
          <IconButton
            disabled={isFirstRow}
            onClick={() => handleArrowUp(row)}
            aria-label="Arrow Up"
            size="small"
          >
            <ArrowUp />
          </IconButton>
          <IconButton
            disabled={isLastRow}
            onClick={() => handleArrowDown(row)}
            aria-label="Arrow Down"
            size="small"
          >
            <ArrowDown />
          </IconButton>
        </>
      )}
      <IconButton onClick={handleDeleteButtonClick} aria-label="Delete" size="small">
        <DeleteIcon />
      </IconButton>
    </div>
  );
};

export default ActionCell;
